import { render, staticRenderFns } from "./ShopCategories.vue?vue&type=template&id=4e177fc6"
import script from "./ShopCategories.vue?vue&type=script&lang=js"
export * from "./ShopCategories.vue?vue&type=script&lang=js"
import style0 from "./ShopCategories.vue?vue&type=style&index=0&id=4e177fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VCombobox,VDataTable,VIcon,VImg,VSwitch})
